export const _setSubject = (state, action) => {
  state.subject = action.payload;
};

// export const _setSubjectIds = (state, action) => {
//   state.subjectIds = action.payload;
// };

export const _setEarliestDate = (state, action) => {
  state.earliestDate = action.payload;
};

export const _setLatestDate = (state, action) => {
  state.latestDate = action.payload;
};

export const _setAscending = (state, action) => {
  state.ascending = action.payload;
};

export const _setIncludeCancelled = (state, action) => {
  state.includeCancelled = action.payload;
};
